'use client'
import { ChatButton } from './ChatButton/ChatButton'
import { ChatDialog } from './ChatDialog/ChatDialog'
import styles from './Chatbot.module.scss'

export function Chatbot() {
	return (
		<aside className={styles.chatAssistant}>
			<ChatButton />
			<ChatDialog />
		</aside>
	)
}
